import { FC } from "react";
import { IconPropsType } from ".";

export const PenaltyHistory: FC<IconPropsType> = (props) => {
  return (
    <svg
      width={props.size ?? 32}
      height={props.size ?? 32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.8884 13.5555C13.343 13.5555 15.3329 11.5657 15.3329 9.1111C15.3329 6.65651 13.343 4.66666 10.8884 4.66666C8.43385 4.66666 6.44401 6.65651 6.44401 9.1111C6.44401 11.5657 8.43385 13.5555 10.8884 13.5555ZM10.8884 16.2222C14.8158 16.2222 17.9995 13.0385 17.9995 9.1111C17.9995 5.18375 14.8158 2 10.8884 2C6.96109 2 3.77734 5.18375 3.77734 9.1111C3.77734 13.0385 6.96109 16.2222 10.8884 16.2222Z"
        fill={props.color ?? "#555555"}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.8884 5.11111C11.6248 5.11111 12.2218 5.70806 12.2218 6.44444V9.1111C12.2218 9.46472 12.0813 9.80386 11.8313 10.0539L10.0535 11.8317C9.53278 12.3524 8.68856 12.3524 8.16786 11.8317C7.64716 11.311 7.64716 10.4668 8.16786 9.94607L9.55511 8.55882V6.44444C9.55511 5.70806 10.1521 5.11111 10.8884 5.11111Z"
        fill={props.color ?? "#555555"}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.444 5.55555C18.444 4.81917 19.0409 4.22222 19.7773 4.22222H23.3329C26.0329 4.22222 28.2218 6.41105 28.2218 9.1111V28.6666C28.2218 29.1717 27.9364 29.6333 27.4847 29.8592C27.033 30.0851 26.4924 30.0363 26.0884 29.7333L23.458 27.7605L21.609 29.6094C21.0883 30.1301 20.2441 30.1301 19.7234 29.6094L17.9995 27.8856L16.2757 29.6094C15.755 30.1301 14.9108 30.1301 14.3901 29.6094L12.6662 27.8856L10.9424 29.6094C10.561 29.9908 9.98755 30.1048 9.48931 29.8985C8.99108 29.6921 8.66623 29.2059 8.66623 28.6666V18.8889C8.66623 18.1525 9.26318 17.5555 9.99956 17.5555C10.7359 17.5555 11.3329 18.1525 11.3329 18.8889V25.4477L11.7234 25.0572C12.2441 24.5365 13.0883 24.5365 13.609 25.0572L15.3329 26.781L17.0567 25.0572C17.5774 24.5365 18.4217 24.5365 18.9424 25.0572L20.6662 26.781L22.3901 25.0572C22.8593 24.588 23.602 24.5352 24.1329 24.9333L25.5551 26V9.1111C25.5551 7.8838 24.5602 6.88888 23.3329 6.88888H19.7773C19.0409 6.88888 18.444 6.29193 18.444 5.55555Z"
        fill={props.color ?? "#555555"}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.3329 13.5555C19.3329 12.8192 19.9298 12.2222 20.6662 12.2222H23.3329C24.0693 12.2222 24.6662 12.8192 24.6662 13.5555C24.6662 14.2919 24.0693 14.8889 23.3329 14.8889H20.6662C19.9298 14.8889 19.3329 14.2919 19.3329 13.5555Z"
        fill={props.color ?? "#555555"}
      />
    </svg>
  );
};
